import { z } from "zod";
import { LLM_MODEL_NAMES, type LLMModelName } from "@/api/types";

const llmEnum = z.enum(LLM_MODEL_NAMES);

/**
 * Zod schema for the meeting-type form. Validates that consensus is set
 * whenever more than one LLM model is selected (mirrors backend invariant
 * in `MeetingTypeCreate`).
 */
export const meetingTypeFormSchema = z
  .object({
    name: z.string().min(1).max(255),
    description: z.string().optional(),
    llm_models: z.array(llmEnum).min(1).max(3),
    consensus_model: llmEnum.optional(),
    // TM-d6d6bf78 — per-type override of the chat system prompt;
    // backend caps at 10000.
    chat_system_prompt: z.string().max(10000).optional(),
  })
  .superRefine((val, ctx) => {
    if (val.llm_models.length > 1 && val.consensus_model === undefined) {
      ctx.addIssue({
        path: ["consensus_model"],
        code: z.ZodIssueCode.custom,
        message: "consensusRequired",
      });
    }
  });

export type MeetingTypeFormValues = z.infer<typeof meetingTypeFormSchema>;

export const EMPTY_MEETING_TYPE_FORM: MeetingTypeFormValues = {
  name: "",
  description: "",
  llm_models: ["claude_opus"],
  chat_system_prompt: "",
};

export function pickKnownModel(name: string): LLMModelName | undefined {
  return (LLM_MODEL_NAMES as readonly string[]).includes(name)
    ? (name as LLMModelName)
    : undefined;
}
